module.exports = __webpack_public_path__ + "static/media/image2.7a3cf9d7.JPG";